/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */

/**
 * 게임 코드
 */
export type WorldcupGrantSourceItemGameCode =
  (typeof WorldcupGrantSourceItemGameCode)[keyof typeof WorldcupGrantSourceItemGameCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorldcupGrantSourceItemGameCode = {
  punch: 'punch',
  timeNyang: 'timeNyang',
  mulNyang: 'mulNyang',
} as const;
